import { apiClient } from 'api/apiClient';

const RESOURCE = '/notifications';

export interface INotification {
	id: number;
	userCode: number;
	sentDateTimeUtc: string;
	createDateTimeUtc: string;
	sentInfo: string;
	sent: boolean;
	notificationPayload: string;
	sentDateTimeInUserTimezone: string;
}

export const getNotifications = async (
	filter?: string
): Promise<INotification[]> => {
	const { data } = await apiClient.get(`${RESOURCE}${filter}`.trim());

	return data;
};
